import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { DisplayConstants, RolesMap } from '../../../helpers/constants';
import Cell from './common/Cell';
import DataCell from './common/DataCell';
import MonitorField from './common/MonitorField';
import Row from './common/Row';

export interface IRoleInfoAreaProps {
  monitor: string;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const getModeLabelForMonitorType = (monitorType: string) => {
  if (DisplayConstants.UpperMonitor === monitorType) {
    return 'ModCon';
  }
  return 'ModSys';
};

export default function RoleInfoArea(props: IRoleInfoAreaProps) {
  const s80 = useSelector((state: any) => state.executor.s80);
  const executor = useSelector((state: any) => state.executor);
  const { monitor } = props;
  const activeMonitor = useSelector(
    (state: any) => state?.executor?.s80?.touchPanelVariables?.activeMonitor
  );
  const expandedRole = (roleStr: any): any =>
    roleStr ? RolesMap[roleStr.toUpperCase()] : '';
  return (
    <Container>
      <Row>
        <Cell width="25%">{getModeLabelForMonitorType(monitor)}:</Cell>
        <DataCell width="75%">
          <MonitorField field="role-info-area-1" />
        </DataCell>
      </Row>
      <Row>
        <Cell width="25%">Active:</Cell>
        <DataCell width="75%">{expandedRole(executor.activeRole)}</DataCell>
      </Row>
      <Row>
        <Cell width="25%">Task:</Cell>
        <DataCell width="75%">
          {(s80.activeVabArray + '').toLowerCase() === 'main array' ||
          activeMonitor !== monitor
            ? ''
            : s80.activeVabArray}
        </DataCell>
      </Row>
      <Row>
        <Cell width="25%">Funct:</Cell>
        <DataCell width="75%">
          <MonitorField field="role-info-area-4" />
        </DataCell>
      </Row>
    </Container>
  );
}
